import template from './noaccess.template.html'

export default {
  template,
  restrict: 'E',
  replace: true,
  controllerAs: 'vm',
  controller: 'NoAccessController',
}
